// Quality related colors
export const qualityClassColor = (evaluationClass, theme) => {
  if (
    !evaluationClass ||
    evaluationClass === 'not_available' ||
    evaluationClass === 'Not available' ||
    typeof evaluationClass !== 'string' ||
    !evaluationClass.trim()
  ) {
    return 'gray';
  }

  if (evaluationClass === 'severe') {
    return theme.palette?.qualityClasses?.skinFoldsSevere;
  } else if (evaluationClass === 'medium') {
    return theme.palette?.qualityClasses?.skinFoldsMedium;
  } else if (evaluationClass === 'mild') {
    return theme.palette?.qualityClasses?.skinFoldsMild;
  } else {
    return theme.palette?.qualityClasses?.[evaluationClass] || theme.palette.accents.dark;
  }
};

// Diagnostics related colors
export const diagnosticsClassColor = (severity, theme) => {
  if (!severity) return '#5b5b5b';

  const colorMapping = {
    no_opacities: theme.palette.diagnosticsClasses.birads1,
    no_microcalc: theme.palette.diagnosticsClasses.birads1,
    birads1: theme.palette.diagnosticsClasses.birads1,
    birads2: theme.palette.diagnosticsClasses.birads2,
    birads3: theme.palette.diagnosticsClasses.birads3,
    birads4: theme.palette.diagnosticsClasses.birads4,
    birads5: theme.palette.diagnosticsClasses.birads5,
    missed: theme.palette.diagnosticsClasses.priorFinding,
    lesionKnown: theme.palette.diagnosticsClasses.lesionKnown,
    vessel: theme.palette.diagnosticsClasses.vessel,
    decrease: theme.palette.diagnosticsClasses.decrease,
    stable: theme.palette.diagnosticsClasses.stable,
    slow: theme.palette.diagnosticsClasses.slow,
    moderate: theme.palette.diagnosticsClasses.moderate,
    fast: theme.palette.diagnosticsClasses.fast,
  };

  return colorMapping[severity] || theme.palette.accents.dark;
};

// Density related colors
export const densityClassColor = (density, theme) => {
  switch (density?.toUpperCase()) {
    case 'A':
      return theme.palette.densityClasses.acrA;
    case 'B':
      return theme.palette.densityClasses.acrB;
    case 'C':
      return theme.palette.densityClasses.acrC;
    case 'D':
      return theme.palette.densityClasses.acrD;
    default:
      return theme.palette.grey[400];
  }
};

// Risk related colors
export const getRiskColor = (risk, theme) => {
  switch (risk?.toLowerCase()) {
    case 'high':
      return theme.palette.riskClasses.high;
    case 'medium':
      return theme.palette.riskClasses.moderate;
    case 'moderate':
      return theme.palette.riskClasses.moderate;
    case 'low':
      return theme.palette.riskClasses.low;
    case 'no_risk':
      return theme.palette.grey[400];
    default:
      return theme.palette.grey[400];
  }
};
